import { i18n } from '../modules/common/i18n/common.i18n'

import { Enums } from '../models/common/enums'
import { ConvertHelper } from './convert-helper'

export class LocalizationHelper {

    public static getLocalizedTextByModule(localizationCategory: Enums.SimaxLocalizationCategory, moduleName: Enums.SimaxModuleName, { collection = 'Common' } = {}): string {
        let textName: string = null

        if (moduleName != Enums.SimaxModuleName.Unknown)
            textName = Enums.SimaxLocalizationCategory[localizationCategory].replace("_MODULE_NAME_", Enums.SimaxModuleName[moduleName].toUpperCase())
        else
            console.log("Cannot find localized text for module name: " + Enums.SimaxModuleName[moduleName])

        return i18n(collection, textName)
    }

    public static getLocalizedText(textName: string, { collection = 'Common' } = {}) {
        if (textName == null) {
            return ''
        }

        return i18n(collection, textName)
    }

    public static getLocalizedEnum<E>(enumObject: any, enumValue: E): string {
        return this.getLocalizedText(ConvertHelper.enumToString(enumObject, enumValue))
    }

}

export namespace LocalizationHelper {
    export class Text {
        public static get AccelerationChose() { return 'AccelerationChose' }
        public static get AcceptDefs() { return 'AcceptDefs' }
        public static get ActionDeviceAnswer() { return 'ActionDeviceAnswer' }
        public static get AccountValidityTime() { return 'AccountValidityTime' }
        public static get Action() { return 'Action' }
        public static get ActionData() { return 'ActionData' }
        public static get ActionOfSendingProfile() { return 'ActionOfSendingProfile' }
        public static get ActionParams() { return 'ActionParams' }
        public static get ActionRun() { return 'ActionRun' }
        public static get ActionSendProfileText() { return 'ActionSendProfileText' }
        public static get Active() { return 'ACTIVE' }
        public static get ActiveDevices() { return 'ActiveApulseDevices' }
        public static get ActiveTariff() { return 'ActiveTariff' }
        public static get Actor() { return 'Actor' }
        public static get Add() { return 'ADD' }
        public static get AddCID() { return 'AddCID' }
        public static get AddedCount() { return 'AddedCount' }
        public static get AdditionalRecipients() { return 'AdditionalRecipients' }
        public static get AddNewDashboard() { return 'AddNewDashboard' }
        public static get AddPackage() { return 'AddPackage' }
        public static get Address() { return 'Address' }
        public static get AddTemplate() { return 'AddTemplate' }
        public static get Aggregation() { return 'Aggregation' }
        public static get AlarmApproved() { return 'AlarmApproved' }
        public static get AlarmDefAdd() { return 'AlarmDefAdd' }
        public static get AlarmDefDelete() { return 'AlarmDefDelete' }
        public static get AlarmDefinitionBulkEdit() { return 'AlarmDefsBulkSave' }
        public static get AlarmDefinitionEdit() { return 'AlarmDefinitionEdit' }
        public static get AlarmDefinitionsSaved() { return 'AlarmDefinitionsSaved' }
        public static get AlarmDefinitionsWereUpdatedToYouWantToSendConfiugrationTo() { return 'AlarmDefinitionsWereUpdatedToYouWantToSendConfiugrationTo' }
        public static get AlarmDefNameError() { return 'AlarmDefNameError' }
        public static get AlarmDefRefType() { return 'AlarmDefRefType' }
        public static get AlarmDefRefTypeList() { return 'AlarmDefRefTypeList' }
        public static get AlarmDefRefTypeOwn() { return 'AlarmDefRefTypeOwn' }
        public static get AlarmDefRefValue() { return 'AlarmDefRefValue' }
        public static get AlarmDefs() { return 'AlarmDefs' }
        public static get AlarmDefsAllMetersSameClassWarning() { return 'AlarmDefsAllMetersSameClassWarning' }
        public static get AlarmDefSelectTitle() { return 'AlarmDefSelectTitle' }
        public static get AlarmDefSelectType() { return 'AlarmDefSelectType' }
        public static get AlarmDeletionIsUnsupported() { return 'AlarmDeletionIsUnsupported' }
        public static get AlarmGroups() { return 'AlarmGroups' }
        public static get AlarmMessage() { return 'AlarmMessage' }
        public static get Alarms() { return 'Alarms' }
        public static get AlarmsApproved() { return 'AlarmsApproved' }
        public static get All() { return 'All' }
        public static get AllCount() { return 'AllCount' }
        public static get AllModules() { return 'AllModules' }
        public static get Allow() { return 'Allow' }
        public static get Amount() { return 'Amount' }
        public static get AppliedConfigurationProfile() { return 'AppliedConfigurationProfile' }
        public static get AppliedDate() { return 'AppliedDate' }
        public static get AppliedOperator() { return 'AppliedOperator' }
        public static get Apply() { return 'Apply' }
        public static get AreYouSure() { return 'AreYouSure' }
        public static get AreYouSureToUseAgain() { return 'AreYouSureToUseAgain' }
        public static get AreYouSureYouWantToRefreshCredit() { return 'AreYouSureYouWantToRefreshCredit' }
        public static get AreYouSureYouWantToSendConfiugrationTo() { return 'AreYouSureYouWantToSendConfiugrationTo' }
        public static get Article(): string { return 'Article' }
        public static get AssignDistributorToRole() { return 'AssignDistributorToRole' }
        public static get AssignedAttachments() { return 'AssignedAttachments' }
        public static get AssignedCount() { return 'AssignedCount' }
        public static get AssignedGroups() { return 'AssignedGroups' }
        public static get AssignedLocations() { return 'AssignedLocations' }
        public static get AssignedTasks() { return 'AssignedTasks' }
        public static get AssignLocations() { return 'AssignLocations' }
        public static get AttachmentDownloadError() { return 'AttachmentDownloadError' }
        public static get Attachments() { return 'Attachments' }
        public static get AttachmentsEdit() { return 'AttachmentsEdit' }
        public static get AttemptedToOpenCreateRelatedItemsFormButProvidedPopupTypeIsNotSupported() { return 'AttemptedToOpenCreateRelatedItemsFormButProvidedPopupTypeIsNotSupported' }
        public static get AttemptedToOpenLocationGroupsEditButPopupDoestNotExist() { return 'AttemptedToOpenLocationGroupsEditButPopupDoestNotExist' }
        public static get AttemptedToSetConfigurationProfileOnProfileButProfileDoesNotExist() { return 'AttemptedToSetConfigurationProfileOnProfileButProfileDoesNotExist' }
        public static get AvailableAt() { return 'AvailableAt' }
        public static get AvailableGroups() { return 'AvailableGroups' }
        public static get AvailableLocations() { return 'AvailableLocations' }
        public static get AvailableTechnicalPermissions() { return 'AvailableTechnicalPermissions' }
        public static get AxisGridColor() { return 'AxisGridColor' }
        public static get AxisXColor() { return 'AxisXColor' }
        public static get AxisYColor() { return 'AxisYColor' }
        public static get BackgroundColor() { return 'BackgroundColor' }
        public static get BalanceFromDevice() { return 'BalanceFromDevice' }
        public static get BalanceOwed() { return 'BalanceOwed' }
        public static get BasicParameters() { return 'BasicParameters' }
        public static get Basics() { return 'Basics' }
        public static get Between() { return 'Between' }
        public static get BookPayment() { return 'BookPayment' }
        public static get BooleanField() { return 'BooleanField' }
        public static get Bottom() { return 'Bottom' }
        public static get BottomLeft() { return 'BottomLeft' }
        public static get BottomRight() { return 'BottomRight' }
        public static get BuiltIn() { return 'BuiltIn' }
        public static get BulkDelete() { return 'BulkDelete' }
        public static get BulkEditIsUnsupported() { return 'BulkEditIsUnsupported' }
        public static get Cancel() { return 'CANCEL' }
        public static get Canceled() { return 'Canceled' }
        public static get CancelLoading() { return 'CancelLoading' }
        public static get CantClosePopupWhileSave() { return 'CantClosePopupWhileSave' }
        public static get CantDeleteExecutOperator() { return 'CantDeleteExecutOperator' }
        public static get CantDeleteSystemAddressBook() { return 'CantDeleteSystemAddressBook' }
        public static get CantSaveMeterNoLocation() { return 'CantSaveMeterNoLocation' }
        public static get Center() { return 'Center' }
        public static get Change() { return 'Change' }
        public static get ChangeDateRange() { return 'ChangeDateRange' }
        public static get ChangeFiltersPopover() { return 'ChangeFiltersPopover' }
        public static get ChangeOfProfile() { return 'ChangeOfProfile' }
        public static get ChangeOfProfileText() { return 'ChangeOfProfileText' }
        public static get ChangePosition() { return 'ChangePosition' }
        public static get ChangeTariff() { return 'ChangeTariff' }
        public static get ChangeTaskStatus() { return 'ChangeTaskStatus' }
        public static get ChildDevices() { return 'ChildDevices' }
        public static get ChildDevicesSaved() { return 'ChildDevicesSaved' }
        public static get ChooseModule() { return 'ChooseModule' }
        public static get ChoosenElements() { return 'ChoosenElements' }
        public static get ChoosePlease() { return 'ChoosePlease' }
        public static get ChosenDeliveryTypes() { return 'ChosenDeliveryTypes' }
        public static get ChosenRecipient() { return 'ChosenRecipient' }
        public static get Cid() { return 'CID' }
        public static get City() { return 'City' }
        public static get Clear() { return 'Clear' }
        public static get ClearSorting() { return 'ClearSorting' }
        public static get ClickMarkerToShowDetails() { return 'ClickMarkerToShowDetails' }
        public static get Client() { return 'CLIENT' }
        public static get Close() { return 'Close' }
        public static get ClosePopupWithoutSendingConfigurationQuestion() { return 'ClosePopupWithoutSendingConfigurationQuestion' }
        public static get Code(): string { return 'Code' }
        public static get Color(): string { return 'Color' }
        public static get ColumnChooserText() { return 'ColumnChooserText' }
        public static get ColumnChooserTitle() { return 'ColumnChooserTitle' }
        public static get CommissionSent() { return 'CommissionSent' }
        public static get Common() { return 'COMMONX' }
        public static get Completed() { return 'Completed' }
        public static get CompletedWithProblems() { return 'CompletedWithProblems' }
        public static get CompleteOrder() { return 'CompleteOrder' }
        public static get Configuration() { return 'Configuration' }
        public static get ConfigurationConsistencyCheck() { return 'ConfigurationConsistencyCheck' }
        public static get ConfigurationConsistent() { return 'ConfigurationConsistent' }
        public static get ConfigurationProfile() { return 'ConfigurationProfile' }
        public static get ConfigurationSaved() { return 'ConfigurationSaved' }
        public static get Confirm() { return 'Confirm' }
        public static get ConfirmChanges() { return 'ConfirmChanges' }
        public static get ConfirmDeleteDashboard() { return 'ConfirmDeleteDashboard' }
        public static get ConfirmDeleteRow() { return 'ConfirmDeleteRow' }
        public static get ConfirmDeleteTask() { return 'ConfirmDeleteTask' }
        public static get ConfirmDepositoryChanges() { return 'ConfirmDepositoryChanges' }
        public static get ConfirmExceptions() { return 'ConfirmExceptions' }
        public static get ConfirmOrder() { return 'ConfirmOrder' }
        public static get Consumer() { return 'Consumer' }
        public static get ConsumerCount() { return 'ConsumerCount' }
        public static get Contains() { return 'Contains' }
        public static get Continue() { return 'Continue' }
        public static get ControlName() { return 'ControlName' }
        public static get Controls() { return 'Controls' }
        public static get Copy() { return 'Copy' }
        public static get CopyFrom() { return 'CopyFrom' }
        public static get CopyTariff() { return 'CopyTariff' }
        public static get CopyTariffSummary() { return 'CopyTariffSummary' }
        public static get CopyTo() { return 'CopyTo' }
        public static get CorrectFormat() { return 'CorrectFormat' }
        public static get CorrelationType() { return 'CorrelationType' }
        public static get CreateSchema() { return 'CreateSchema' }
        public static get CreditAmount() { return 'CreditAmount' }
        public static get CreditAmountCannotBeZero() { return 'CreditAmountCannotBeZero' }
        public static get CreditAmountIsRequired() { return 'CreditAmountIsRequired' }
        public static get CreditRefreshSent() { return 'CreditRefreshSent' }
        public static get CreditTopup() { return 'CreditTopup' }
        public static get CurrentCredit() { return 'CurrentCredit' }
        public static get CurrentDevice() { return 'CurrentDevice' }
        public static get CurrentLocation() { return 'CurrentLocation' }
        public static get CurrentMeter() { return 'CurrentMeter' }
        public static get CurrentView() { return 'CurrentView' }
        public static get Custom() { return 'Custom' }
        public static get CustomPermissions() { return 'CustomPermissions' }
        public static get Dashboard() { return 'Dashboard' }
        public static get DashboardDeleted() { return 'DashboardDeleted' }
        public static get DataType() { return 'DataType' }
        public static get Date() { return 'Date' }
        public static get DateRange() { return 'DateRange' }
        public static get DateTime() { return 'DateTime' }
        public static get DeactivateSourceTariffQuestion() { return 'DeactivateSourceTariffQuestion' }
        public static get DecommissionSent() { return 'DecommissionSent' }
        public static get DefExists() { return 'DefExists' }
        public static get DefinedCount() { return 'DefinedCount' }
        public static get Delete() { return 'Delete' }
        public static get DeleteLocation() { return 'DeleteLocation' }
        public static get DeleteLogoQuestion() { return 'DeleteLogoQuestion' }
        public static get DeleteReferenceObject() { return 'DeleteReferenceObject' }
        public static get DeleteTemplateQuestion() { return 'DeleteTemplateQuestion' }
        public static get DeletingInProgress() { return 'DeletingInProgress' }
        public static get Depository() { return 'DEPOSITORY' }
        public static get DepositoryNothingSelected() { return 'DepositoryNothingSelected' }
        public static get Description() { return 'DESCRIPTION' }
        public static get Device() { return 'DEVICE' }
        public static get Device1() { return 'Device1' }
        public static get DeviceConfigurationInconsistencyError() { return 'DeviceConfigurationInconsistencyError' }
        public static get DeviceParameters() { return 'DeviceParameters' }
        public static get DeviceRelocation() { return 'DeviceRelocation' }
        public static get Devices() { return 'Devices' }
        public static get DevicesEdit() { return 'DevicesEdit' }
        public static get DifferentStatusesEditWarning() { return 'DifferentStatusesEditWarning' }
        public static get Direction() { return 'Direction' }
        public static get Distance() { return 'Distance' }
        public static get Distributor() { return 'DISTRIBUTOR' }
        public static get Done() { return 'DONE' }
        public static get Download() { return 'Download' }
        public static get DownloadTemplate() { return 'DownloadTemplate' }
        public static get DupplicatedTemplateWarning() { return 'DupplicatedTemplateWarning' }
        public static get Duration() { return 'Duration' }
        public static get DurationEstimate(): string { return 'DurationEstimate' }
        public static get DurationFormat() { return 'DurationFormat' }
        public static get DxDashboard() { return 'DxDashboard' }
        public static get Edit() { return 'EDIT' }
        public static get EditDashboardOptions() { return 'EditDashboardOptions' }
        public static get EditIsEnableWithinOneDistributor() { return 'EditIsEnableWithinOneDistributor' }
        public static get EditReferenceObject() { return 'EditReferenceObject' }
        public static get EditTemplate() { return 'EditTemplate' }
        public static get EffectivePermissions() { return 'EffectivePermissions' }
        public static get Email() { return 'Email' }
        public static get EmergencyCredit() { return 'EmergencyCredit' }
        public static get End() { return 'End' }
        public static get EndsWith() { return 'EndsWith' }
        public static get EndTime() { return 'EndTime' }
        public static get Equal() { return 'Equal' }
        public static get Equipment() { return 'Equipment' }
        public static get EquipmentAssigned() { return 'EquipmentAssigned' }
        public static get ErrorContactWithAdmin() { return 'ErrorContactWithAdmin' }
        public static get ErrorCount() { return 'ErrorCount' }
        public static get Errors() { return 'Errors' }
        public static get EventType() { return 'EventType' }
        public static get ExceptionOccuredPleaseContactAnAdministrator() { return 'ExceptionOccuredPleaseContactAnAdministrator' }
        public static get ExecuteActionAfterProcessingPacket() { return 'ExecuteActionAfterProcessingPacket' }
        public static get ExecuteActionAfterReceivingPacket() { return 'ExecuteActionAfterReceivingPacket' }
        public static get ExecuteActionAt() { return 'ExecuteActionAt' }
        public static get Export() { return 'Export' }
        public static get ExportParameters() { return 'ExportParameters' }
        public static get ExternalFile() { return 'ExternalFile' }
        public static get FailedToOpenCreateRelatedItemsForm() { return 'FailedToOpenCreateRelatedItemsForm' }
        public static get FailedToOpenMassGroupingLocationAssign() { return 'FailedToOpenMassGroupingLocationAssign' }
        public static get FailedToSaveSchema() { return 'FailedToSaveSchema' }
        public static get False() { return 'FALSE' }
        public static get Favorites() { return 'Favorites' }
        public static get FavoritesAdd() { return 'FavoritesAdd' }
        public static get FavoritesRemove() { return 'FavoritesRemove' }
        public static get FieldOfType() { return 'FieldOfType' }
        public static get Fill() { return 'Fill' }
        public static get FillAllRequiredFields() { return 'FillAllRequiredFields' }
        public static get FillingDate() { return 'FillingDate' }
        public static get Filter() { return 'Filter' }
        public static get FilterName() { return 'FilterName' };
        public static get FilterOptions() { return 'FilterOptions' };
        public static get FindPackageBySerialNbr() { return 'FindPackageBySerialNbr' }
        public static get Finish() { return 'Finish' };
        public static get FirstName() { return 'FirstName' }
        public static get Fitter() { return 'FITTER' }
        public static get FitToScreen() { return 'FitToScreen' }
        public static get Fix() { return 'Fix' }
        public static get FontColor() { return 'FontColor' }
        public static get ForgotPassword() { return 'ForgotPassword' }
        public static get From() { return 'From' }
        public static get Fullscreen() { return 'Fullscreen' };
        public static get GetAttachment() { return 'GetAttachment' }
        public static get GetPackedAttachment() { return 'GetPackedAttachment' }
        public static get GreaterThan() { return 'GreaterThan' }
        public static get GreaterThanOrEqual() { return 'GreaterThanOrEqual' }
        public static get GroupEdit() { return 'GroupEdit' }
        public static get GroupPanelText() { return 'GroupPanelText' }
        public static get Groups() { return 'GROUPS' }
        public static get GroupsEdit() { return 'GroupsEdit' }
        public static get History() { return 'HISTORY' }
        public static get HubDetails() { return 'HubDetails' }
        public static get Icon() { return 'Icon' }
        public static get IconPosition() { return 'IconPosition' }
        public static get IconStretch() { return 'IconStretch' }
        public static get IdDistributor() { return 'IdDistributor' }
        public static get ImportAlarms() { return 'ImportAlarms' }
        public static get ImportDeviceConnections() { return 'ImportDeviceConnections' }
        public static get ImportDevices() { return 'ImportDevices' }
        public static get ImportIssues() { return 'ImportIssues' }
        public static get ImportLocations() { return 'ImportLocations' }
        public static get ImportMeters() { return 'ImportMeters' }
        public static get ImportParameters() { return 'ImportParameters' }
        public static get ImportRoutes() { return 'ImportRoutes' }
        public static get ImportSummary() { return 'ImportSummary' }
        public static get ImportTasks() { return 'ImportTasks' }
        public static get InactiveDevices() { return 'InactiveApulseDevices' }
        public static get Incoming() { return 'Incoming' }
        public static get IncorrectData() { return 'IncorrectData' }
        public static get Index() { return 'INDEX' }
        public static get InformationAboutConsumer() { return 'InformationAboutConsumer' }
        public static get InstalledCount() { return 'InstalledCount' }
        public static get InstalledEquipment() { return 'InstalledEquipment' }
        public static get Integer() { return 'Integer' }
        public static get IntegerField() { return 'IntegerField' }
        public static get Interaction() { return 'Interaction' }
        public static get InvalidCurrencyFormat() { return 'InvalidCurrencyFormat' }
        public static get InvalidDate() { return 'InvalidDate' }
        public static get IsEnabled() { return 'IsEnabled' }
        public static get IsFullscreenButtonHidden() { return 'IsFullscreenButtonHidden' }
        public static get IsHorizontalGridHidden() { return 'IsHorizontalGridHidden' }
        public static get IsLegendButtonHidden() { return 'IsLegendButtonHidden' }
        public static get IsLegendValueVisible() { return 'IsLegendValueVisible' }
        public static get IsSeriesLabelVisible() { return 'IsSeriesLabelVisible' }
        public static get IssueAttachmentDelete() { return 'IssueAttachmentDelete' }
        public static get IssueAttachmentDeleteError() { return 'IssueAttachmentDeleteError' }
        public static get IssueAttachmentSave() { return 'IssueAttachmentSave' }
        public static get IssueAttachmentSaveError() { return 'IssueAttachmentSaveError' }
        public static get IssueCreationDate() { return 'IssueCreationDate' }
        public static get IssueDelete() { return 'IssueDelete' }
        public static get Issues() { return 'Issues' }
        public static get IssuesCount() { return 'IssuesCount' }
        public static get IssueSave() { return 'IssueSave' }
        public static get IsTableVisible() { return "Pokaż tabelę" }
        public static get IsTooltipHidden() { return 'IsTooltipHidden' }
        public static get IsVerticalGridHidden() { return 'IsVerticalGridHidden' }
        public static get IsXAxisTitleHidden() { return 'IsXAxisTitleHidden' }
        public static get IsYAxisTitleHidden() { return 'IsYAxisTitleHidden' }
        public static get ItemsPosition() { return 'ItemsPosition' }
        public static get KeepAspectRatio() { return 'KeepAspectRatio' }
        public static get KPI() { return 'KPI' }
        public static get LastCreditUpdate() { return 'LastCreditUpdate' }
        public static get Latest() { return 'Latest' }
        public static get Left() { return 'Left' }
        public static get LeftPosition() { return 'LeftPosition' }
        public static get Legend() { return 'Legend' }
        public static get LessThan() { return 'LessThan' }
        public static get LessThanOrEqual() { return 'LessThanOrEqual' }
        public static get LoadExternalFile() { return 'LoadExternalFile' }
        public static get Loading() { return 'Loading' }
        public static get Location() { return 'Location' }
        public static get LocationAddressChangeQuestion() { return 'LocationAddressChangeQuestion' }
        public static get LocationAddressCompareAlert() { return 'LocationAddressCompareAlert' }
        public static get LocationAssigning() { return 'LocationAssigning' }
        public static get LocationCount() { return 'LocationCount' }
        public static get LocationDeleted() { return 'LocationDeleted' }
        public static get LocationParameters() { return 'LocationParameters' }
        public static get LocationProfileSaved() { return 'LocationProfileSaved' }
        public static get LocationProfileSaveError() { return 'LocationProfileSaveError' }
        public static get Locations() { return 'LOCATIONS' }
        public static get Login() { return 'Login' }
        public static get Logo() { return 'Logo' }
        public static get LongInteger() { return 'LongInteger' }
        public static get ManageValve() { return 'ManageValve' }
        public static get Map() { return 'Map' }
        public static get MarkerBounce() { return 'MarkerBounce' }
        public static get MarkerFilter() { return 'MarkerFilter' }
        public static get MassGroupAssigning() { return 'MassGroupAssigning' }
        public static get MassGroupAssigningSummary() { return 'MassGroupAssigningSummary' }
        public static get MassIssueCreate() { return 'MassIssueCreate' }
        public static get MassSendConfigurationProfile() { return 'MassSendConfigurationProfile' }
        public static get MassTaskCreate() { return 'MassTaskCreate' }
        public static get MaxNumberOfCharacters() { return 'MaxNumberOfCharacters' }
        public static get MaxRange() { return 'MaxRange' }
        public static get MaxWidthInPx() { return 'MaxWidthInPx' }
        public static get Measurements() { return 'Measurements' }
        public static get MeasurmentsDetails() { return 'MeasurmentsDetails' }
        public static get MessageTemplates() { return 'MessageTemplates' }
        public static get Meter() { return 'Meter' }
        public static get MeterAlarmDefEdit() { return 'MeterAlarmDefEdit' }
        public static get MeterRelocation() { return 'MeterRelocation' }
        public static get Meters() { return 'Meters' }
        public static get MetersEdit() { return 'MetersEdit' }
        public static get MinDepositoryStates() { return 'MinDepositoryStates' }
        public static get MinNumberOfCharacters() { return 'MinNumberOfCharacters' }
        public static get MinRange() { return 'MinRange' }
        public static get Module() { return 'Module' }
        public static get ModuleName() { return 'ModuleName' }
        public static get MoreFilters() { return 'MoreFilters' }
        public static get MultipleParentDevices() { return 'multipleParentDevices' }
        public static get MultipleSelected() { return 'MultipleSelected' }
        public static get Name() { return 'NAME' }
        public static get NewElement() { return 'NewElement' }
        public static get NewPayment() { return 'NewPayment' }
        public static get NextCoordinates() { return 'NextCoordinates' }
        public static get NextStep() { return 'NextStep' }
        public static get No() { return 'No' }
        public static get NoActionToSend() { return 'NoActionToSend' }
        public static get NoActiveAccordions() { return 'NoActiveAccordions' }
        public static get NoAssignedAlarmGroups() { return 'NoAssignedAlarmGroups' }
        public static get NoAssignedDepository(): string { return 'NoAssignedDepository' }
        public static get NoAssignedMeter() { return 'NoAssignedMeter' }
        public static get NoAssignedTechnicalPermissions() { return 'NoAssignedTechnicalPermissions' }
        public static get NoConfigurationProfileSelected() { return 'NoConfigurationProfileSelected' }
        public static get NoData() { return 'NODATA' }
        public static get NoDataToShow() { return 'NoDataToShow' }
        public static get NoDefinedContent() { return 'NoDefinedContent' }
        public static get NoDefinedTariffToLocation() { return 'NoDefinedTariffToLocation' }
        public static get NoDevicesToSendProfileConfiguration() { return 'NoDevicesToSendProfileConfiguration' }
        public static get NoHub() { return 'NoHub' }
        public static get NoInformation() { return 'NoInformation' }
        public static get NoItemsToShow() { return 'NoItemsToShow' }
        public static get NoLocationToCreateTheAction() { return 'NoLocationToCreateTheAction' }
        public static get None() { return 'None' }
        public static get NoResults() { return 'NoResults' }
        public static get NoSchema() { return 'NoSchema' }
        public static get NotAvailableAbbr() { return 'NotAvailableAbbr' };
        public static get NotContains() { return 'NotContains' }
        public static get NoTemplateToLoad() { return 'NoTemplateToLoad' }
        public static get NotEqual() { return 'NotEqual' }
        public static get Notes() { return 'Notes' }
        public static get NothingSelected() { return 'NothingSelected' }
        public static get NotificationByEmail() { return 'NotificationByEmail' }
        public static get NotificationBySms() { return 'NotificationBySms' }
        public static get NotificationDeliveryType() { return 'NotificationDeliveryType' }
        public static get Notifications() { return 'NOTIFICATIONS' }
        public static get NotificationSendFailed() { return 'NotificationSendFailed' }
        public static get NotificationSent() { return 'NotificationSent' }
        public static get NotificationText() { return 'NotificationText' }
        public static get NotRetransmitted() { return 'NotRetransmitted' }
        public static get NumberMaxPrecision() { return 'NumberMaxPrecision' }
        public static get NumberMaxValue() { return 'NumberMaxValue' }
        public static get NumberMinPrecision() { return 'NumberMinPrecision' }
        public static get NumberMinValue() { return 'NumberMinValue' }
        public static get NumberPrecisionRange() { return 'NumberPrecisionRange' }
        public static get NumericField() { return 'NumericField' }
        public static get Occurrences() { return 'Occurrences' }
        public static get Ok() { return 'Ok' }
        public static get Operator() { return 'Operator' }
        public static get Operators() { return 'Operators' }
        public static get OperatorsEdit() { return 'OperatorsEdit' }
        public static get OperatorWithoutPermissionAndDepository() { return 'OperatorWithoutPermissionAndDepository' }
        public static get Order() { return 'Order' }
        public static get OrderedToPay() { return 'OrderedToPay' }
        public static get Outgoing() { return 'Outgoing' }
        public static get OwedUpdated() { return 'OwedUpdated' }
        public static get Package(): string { return 'Package' }
        public static get PackageContent() { return 'PackageContent' }
        public static get PackageNotFound() { return 'PackageNotFound' }
        public static get PackagesSaved(): string { return 'PackagesSaved' }
        public static get PacketTime() { return 'PacketTime' }
        public static get Parameters() { return 'Parameters' }
        public static get ParentDevices() { return 'ParentDevices' }
        public static get Pause() { return 'Pause' }
        public static get PaymentAmount() { return 'PaymentAmount' }
        public static get PaymentDone() { return 'PaymentDone' }
        public static get PaymentModuleNumber() { return 'PaymentModuleNumber' }
        public static get PaymentModules() { return 'PaymentModules' }
        public static get Payments() { return 'Payments' }
        public static get PaymentSystem() { return 'PaymentSystem' }
        public static get PaymentWarningMessage() { return 'PaymentWarningMessage' }
        public static get PermissionInfoText() { return 'PermissionInfoText' }
        public static get PersonalDetails() { return 'PersonalDetails' }
        public static get PlanDelivery() { return 'PlanDelivery' }
        public static get Play() { return 'Play' }
        public static get PleaseWait() { return 'PleaseWait' }
        public static get PluginNotConfigured() { return 'PluginNotConfigured' }
        public static get Points() { return 'Points' }
        public static get PointsEdit() { return 'PointsEdit' }
        public static get Preferences() { return 'Preferences' }
        public static get PrepaidCommission() { return 'PrepaidCommission' }
        public static get PrepaidCommissionConfirm() { return 'PrepaidCommissionConfirm' }
        public static get PrepaidDecommission() { return 'PrepaidDecommission' }
        public static get PrepaidDecommissionConfirm() { return 'PrepaidDecommissionConfirm' }
        public static get PreviousCoordinates() { return 'PreviousCoordinates' }
        public static get PreviousStep() { return 'PreviousStep' }
        public static get Product() { return 'Product' }
        public static get Profile() { return 'Profile' }
        public static get ProfileConfiguration() { return 'ProfileConfiguration' }
        public static get ProfileNotApplied() { return 'ProfileNotApplied' }
        public static get Progress() { return 'Progress' }
        public static get ProtocolIn() { return 'ProtocolIn' }
        public static get ProtocolOut() { return 'ProtocolOut' }
        public static get RadioDeviceDetails() { return 'RadioDeviceDetails' }
        public static get ReadLocations() { return 'ReadLocations' }
        public static get Real() { return 'Real' }
        public static get Recent() { return 'Recent' }
        public static get Records() { return 'Records' }
        public static get ReferenceObject() { return 'ReferenceObject' }
        public static get ReferenceType() { return 'ReferenceType' }
        public static get Refresh() { return 'Refresh' };
        public static get RefreshCredit() { return 'RefreshCredit' };
        public static get RefreshLocation() { return 'RefreshLocation' }
        public static get RelatedOrders() { return 'RelatedOrders' }
        public static get RelatedPackages() { return 'RelatedPackages' }
        public static get RemoveDeviceToo() { return 'RemoveDeviceToo' }
        public static get RemoveMeterToo() { return 'RemoveMeterToo' }
        public static get Repayment() { return 'Repayment' }
        public static get ReplenishmentStocks() { return 'ReplenishmentStocks' }
        public static get ReplenishmentStocksQuestion() { return 'ReplenishmentStocksQuestion' }
        public static get RequiredField() { return 'RequiredField' }
        public static get RequiredTechnicalPermissions() { return 'RequiredTechnicalPermissions' }
        public static get Reset() { return 'Reset' }
        public static get ResetFilter() { return 'ResetFilter' }
        public static get Result() { return 'Result' }
        public static get Retransmitted() { return 'Retransmitted' }
        public static get Right() { return 'Right' }
        public static get RightPosition() { return 'RightPosition' }
        public static get Roles() { return 'Roles' }
        public static get Rotate() { return 'Rotate' }
        public static get RouteDelete() { return 'RouteDelete' }
        public static get Routes() { return 'Routes' }
        public static get RouteSaved() { return 'RouteSaved' }
        public static get Run() { return 'Run' }
        public static get RunActions() { return 'RunActions' }
        public static get Save() { return 'Save' }
        public static get SaveFailed() { return 'SaveFailed' }
        public static get SaveOperatorToOperatorGroupValidationError() { return 'SaveOperatorToOperatorGroupValidationError' }
        public static get SaveOrders() { return 'SaveOrders' }
        public static get SavePackage() { return 'SavePackage' }
        public static get SaveTechnicalPermissionToOperatorGroupValidationError() { return 'SaveTechnicalPermissionToOperatorGroupValidationError' }
        public static get SavingInProgress() { return 'SavingInProgress' }
        public static get SavingSuccessful() { return 'SavingSuccessful' }
        public static get SavingSummary() { return 'SavingSummary' }
        public static get Schedule() { return 'Schedule' }
        public static get ScheduleActionExecution() { return 'ScheduleActionExecution' }
        public static get Schema() { return 'Schema' }
        public static get SchemaSaved() { return 'SchemaSaved' }
        public static get ScriptExecTime() { return 'ScriptExecTime' }
        public static get ScriptResultError() { return 'ScriptResultError' }
        public static get ScriptRunError() { return 'ScriptRunError' }
        public static get ScriptsDownloadError() { return 'ScriptsDownloadError' }
        public static get ScriptSelect() { return 'ScriptSelect' }
        public static get ScriptStarted() { return 'ScriptStarted' }
        public static get ScriptStopError() { return 'ScriptStopError' }
        public static get ScriptStopped() { return 'ScriptStopped' }
        public static get ScriptSuccessResult() { return 'ScriptSuccessResult' }
        public static get Search() { return 'Search' }
        public static get Security() { return 'SECURITY' }
        public static get Select() { return 'Select' }
        public static get SelectConsumer() { return 'SelectConsumer' }
        public static get SelectDepository() { return 'SelectDepository' }
        public static get SelectDepositoryToAssign() { return 'SelectDepositoryToAssign' }
        public static get SelectFromMap() { return 'SelectFromMap' }
        public static get SelectingTechnicalPermissions() { return 'SelectingTechnicalPermissions' }
        public static get SelectLevel() { return 'SelectLevel' }
        public static get SelectLocationToAssign() { return 'SelectLocationToAssign' }
        public static get SelectModuleToRedirect() { return 'SelectModuleToRedirect' }
        public static get SelectProfile() { return 'SelectProfile' }
        public static get SelectRowToShowDetails() { return 'SelectRowToShowDetails' }
        public static get SelectSeries() { return 'SelectSeries' }
        public static get SelectServicemans() { return 'SelectServicemans' }
        public static get SelectTariff() { return 'SelectTariff' }
        public static get SelectTemplate() { return 'SelectTemplate' }
        public static get Send() { return 'Send' }
        public static get SendAction() { return 'SendAction' }
        public static get SendActionToDevice() { return 'SendActionToDevice' }
        public static get SendConfigurationTo() { return 'SendConfigurationTo' }
        public static get SendConfigurationToDevice() { return 'SendConfigurationToDevice' }
        public static get SendDeviceConfigurationError() { return 'SendDeviceConfigurationError' }
        public static get SendImageNotification() { return 'SendImageNotification' }
        public static get SendNotification() { return 'SendNotification' }
        public static get SendProfile() { return 'SendProfile' }
        public static get SendTheConfiugrationToThe() { return 'SendTheConfiugrationToThe' }
        public static get SentMessages() { return 'SentMessages' }
        public static get SerialNbr() { return 'SerialNbr' }
        public static get Servicemans() { return 'Servicemans' }
        public static get Set() { return 'Set' };
        public static get SetDefinitionName() { return 'SetDefinitionName' }
        public static get SetUpDefaultDateRange() { return 'SetUpDefaultDateRange' }
        public static get ShowCashierPanel() { return 'ShowCashierPanel' }
        public static get ShowChart() { return 'ShowChart' }
        public static get ShowConsumers() { return 'ShowConsumers' }
        public static get ShowDetails() { return 'ShowDetails' }
        public static get ShowDevices() { return 'ShowDevices' }
        public static get ShowGrid() { return 'ShowGrid' }
        public static get ShowHideRanges() { return 'ShowHideRanges' }
        public static get ShowHubs() { return 'ShowHubs' }
        public static get ShowIssues() { return 'ShowIssues' }
        public static get ShowLocationDetails() { return 'ShowLocationDetails' };
        public static get ShowLocations() { return 'ShowLocations' }
        public static get ShowManualReadoutHistory() { return 'ShowManualReadoutHistory' }
        public static get ShowMeters() { return 'ShowMeters' }
        public static get ShowOptions() { return 'ShowOptions' }
        public static get ShowRadioDevices() { return 'ShowRadioDevices' }
        public static get ShowRecentActions() { return 'ShowRecentActions' }
        public static get ShowSimCards() { return 'ShowSimCards' }
        public static get ShowTariffs() { return 'ShowTariffs' }
        public static get ShowTasks() { return 'ShowTasks' }
        public static get SignOut() { return 'SignOut' }
        public static get Size() { return 'Size' }
        public static get SkippedCount() { return 'SkippedCount' }
        public static get SlotNbr() { return 'SlotNbr' }
        public static get SlotType() { return 'SlotType' }
        public static get Sms() { return 'Sms' }
        public static get SortAscending() { return 'SortAscending' }
        public static get SortDescending() { return 'SortDescending' }
        public static get SpecificParameters() { return 'SpecificParameters' }
        public static get Start() { return 'Start' }
        public static get StartAction() { return 'StartAction' }
        public static get StartProcess() { return 'StartProcess' }
        public static get StartSave() { return 'StartSave' }
        public static get StartsWith() { return 'StartsWith' }
        public static get StartTime() { return 'StartTime' }
        public static get StartupSerie() { return 'StartupSerie' }
        public static get State() { return 'State' }
        public static get Status() { return 'Status' }
        public static get Stop() { return 'Stop' }
        public static get StorageDetails() { return 'StorageDetails' }
        public static get StorageState() { return 'StorageState' }
        public static get Structure() { return 'Structure' }
        public static get Submit() { return 'Submit' }
        public static get SubmitAll() { return 'SubmitAll' }
        public static get SuccessCount() { return 'SuccessCount' }
        public static get SuppliersEdit() { return 'SuppliersEdit' }
        public static get Surname() { return 'Surname' }
        public static get Tariff() { return 'Tariff' }
        public static get TariffActivationTime() { return 'TariffActivationTime' }
        public static get TariffCode() { return 'TariffCode' }
        public static get TariffCopy() { return 'TariffCopy' }
        public static get Task() { return 'Task' }
        public static get TaskAttachmentNoPreview() { return 'TaskAttachmentNoPreview' }
        public static get TaskAttachmentPreviewResize() { return 'TaskAttachmentPreviewResize' }
        public static get TaskCount() { return 'TaskCount' }
        public static get TaskDeleted() { return 'TaskDeleted' }
        public static get TaskDeleteError() { return 'TaskDeleteError' }
        public static get TaskEquipmentChangeError() { return 'TaskEquipmentChangeError' }
        public static get Tasks() { return 'Tasks' }
        public static get TasksEdit() { return 'TasksEdit' }
        public static get TaskStatusChange() { return 'TaskStatusChange' }
        public static get TechnicalPermissions() { return 'TechnicalPermissions' }
        public static get TemplateDeleted() { return 'TemplateDeleted' }
        public static get TemplateDeleteError() { return 'TemplateDeleteError' }
        public static get TemplatePreview() { return 'TemplatePreview' }
        public static get TemplateSaved() { return 'TemplateSaved' }
        public static get TemplateSaveError() { return 'TemplateSaveError' }
        public static get Text() { return 'Text' }
        public static get Time() { return 'Time' }
        public static get TimeLeftToRefresh() { return 'TimeLeftToRefresh' }
        public static get TitleColor() { return 'TitleColor' }
        public static get TitlePosition() { return 'TitlePosition' }
        public static get TitleSize() { return 'TitleSize' }
        public static get To() { return 'To' }
        public static get ToDevice() { return 'ToDevice' }
        public static get ToggleDetailsRows() { return 'ToggleDetailsRows' }
        public static get ToLocation() { return 'ToLocation' }
        public static get ToMeter() { return 'ToMeter' }
        public static get Tooltip() { return 'Tooltip' };
        public static get TooltipBackgroundColor() { return 'TooltipBackgroundColor' }
        public static get TooltipValueColor() { return 'TooltipValueColor' }
        public static get Top() { return 'Top' }
        public static get TopLeft() { return 'TopLeft' }
        public static get TopRight() { return 'TopRight' }
        public static get TopUpRollback() { return 'TopUpRollback' }
        public static get TopUpRollbackDone() { return 'TopUpRollbackDone' }
        public static get TopUpRollbackQueston() { return 'TopUpRollbackQueston' }
        public static get Tracking() { return 'Tracking' }
        public static get TransactionHistory() { return 'TransactionHistory' }
        public static get Transactions() { return 'Transactions' }
        public static get TransmissionDriver() { return 'TransmissionDriver' }
        public static get TransmissionType() { return 'TransmissionType' }
        public static get True() { return 'TRUE' }
        public static get Type() { return 'Type' }
        public static get TypeBinary() { return 'TypeBinary' }
        public static get TypeBoolean() { return 'TypeBoolean' }
        public static get TypeDate() { return 'TypeDate' }
        public static get TypeDatetime() { return 'TypeDatetime' }
        public static get TypeDecimal() { return 'TypeDecimal' }
        public static get TypeInteger() { return 'TypeInteger' }
        public static get TypeReal() { return 'TypeReal' }
        public static get TypeTime() { return 'TypeTime' }
        public static get UnexpectedError() { return 'UnexpectedError' }
        public static get Unfix() { return 'Unfix' }
        public static get Uniform() { return 'Uniform' }
        public static get UninstalledEquipment() { return 'UninstalledEquipment' }
        public static get Unit() { return 'UNIT' }
        public static get Unknown() { return 'Unknown' }
        public static get Unlimited() { return 'Unlimited' }
        public static get UnsavedChanges() { return 'UnsavedChanges' }
        public static get UpdateOwed() { return 'UpdateOwed' }
        public static get Upload() { return 'Upload' }
        public static get UseAgain() { return 'UseAgain' }
        public static get User() { return 'User' }
        public static get UserDeleteError() { return 'UserDeleteError' }
        public static get Validate() { return 'Validate' }
        public static get Value() { return 'VALUE' }
        public static get ValueColor() { return 'ValueColor' }
        public static get ValueIsOutOfRange() { return 'ValueIsOutOfRange' }
        public static get ValuePosition() { return 'ValuePosition' }
        public static get ValueSize() { return 'ValueSize' }
        public static get ValveControl() { return 'ValveControl' };
        public static get ValveState() { return 'ValveState' };
        public static get Warning() { return 'Warning' }
        public static get WarningCount() { return 'WarningCount' }
        public static get WatchErrors() { return 'WatchErrors' }
        public static get WebServiceException() { return 'WebServiceException' }
        public static get WidthInPx() { return 'WidthInPx' }
        public static get Yes() { return 'Yes' }
        public static get YouCantEditAlarmDefinitionsIfDeviceHasNoMeterAssigned() { return 'YouCantEditAlarmDefinitionsIfDeviceHasNoMeterAssigned' }
        public static get YouHaveToSelectAtleastOneLocation() { return 'YouHaveToSelectAtleastOneLocation' }
        public static get Zip() { return 'Zip' }
    }
}